module.exports = __webpack_public_path__ + "img/grass.d335465f.png";